export default __webpack_public_path__ + "static/media/greenBackArrow.711476de.svg";